"use client";

import * as DropdownMenuPrimitive from "@radix-ui/react-dropdown-menu";
import { type ComponentProps } from "react";

import { cn } from "../../utils/cn.util";

export type DropdownMenuGroupProps = ComponentProps<typeof DropdownMenuPrimitive.Group>;

export const Group = ({ ref, className, ...props }: DropdownMenuGroupProps) => (
  <DropdownMenuPrimitive.Group ref={ref} className={cn("flex flex-col gap-1", className)} {...props} />
);

Group.displayName = DropdownMenuPrimitive.Group.displayName;
